import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import ReactQueryProvider from './providers/ReactQueryProvider';
import CanonicalWrapper from './components/CanonicalWrapper';
import { ModalProvider } from './components/ModalContext'; // Import ModalProvider
import LandingPage from './pages/Landing';
import AboutUs from './pages/AboutUs';
import Products from './pages/Products';
import Careers from './pages/Careers';
import Blog from './pages/Blog';
import BlogDetails from './pages/BlogDetails';
import Modal from './components/Modal'; // Ensure you have Modal component
import Header from './components/Header'; // Assuming you have a Header component
import TransXT from './pages/TransXT';
import ScrollToTop from './ScrollToTop';
import Resources from './pages/Resources';
import PrivacyPolicy from './pages/PrivacyPolicy';

const App = () => {
  return (
    <ReactQueryProvider>
      <ModalProvider>
        <BrowserRouter>
        <ScrollToTop/>
        <div className="app-container">
          <Header />
          <CanonicalWrapper>
            <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route path="AboutUs" element={<AboutUs />} />
              <Route path="Careers" element={<Careers />} />
              <Route path="TransXT" element={<TransXT />} />
              <Route path="Blogs" element={<Blog />} />
              <Route path="Resources/:resourcetype" element={<Resources />} />
              <Route path="Blogs/:mainTitleKey" element={<BlogDetails />} />
              <Route path="/products">
                <Route path="upi" element={<Products />} />
                <Route path="imps" element={<Products />} />
                <Route path="bbps" element={<Products />} />
                <Route path="aeps" element={<Products />} />
              </Route>
              <Route path="PrivacyPolicy" element={<PrivacyPolicy />} />
              <Route path="*" element={<LandingPage />} />
            </Routes>
          </CanonicalWrapper>
        </div>
          <Modal />
        </BrowserRouter>
      </ModalProvider>
    </ReactQueryProvider>
  );
}

export default App;
